import { useExecution } from './execution-context';

interface UseProposalExecutionStateOptions {
  proposalId: string | string[] | null;
  isServerExecuting?: boolean;
  isRequestPending?: boolean;
}

/**
 * Combines request-local, provider-owned, and proposal-response execution state.
 * Callers pass `isServerExecuting` from their existing polled proposal fetch so
 * cross-user ownership does not require a second polling request.
 */
export function useProposalExecutionState({
  proposalId,
  isServerExecuting = false,
  isRequestPending = false,
}: UseProposalExecutionStateOptions) {
  const { isExecutionActive, startExecution } = useExecution();
  const proposalIds = Array.isArray(proposalId)
    ? proposalId
    : proposalId
      ? [proposalId]
      : [];
  const isLocallyTracked = proposalIds.some((id) =>
    isExecutionActive('proposal', id)
  );

  return {
    isExecuting: Boolean(
      proposalIds.length > 0 &&
        (isRequestPending || isLocallyTracked || isServerExecuting)
    ),
    startExecution,
  };
}
